export default {
  administrationMetadata: {
    banned: 'Banned',
    registrationDate: 'Reg. date',
    lastEnter: 'Last enter',
    companies: 'Companies',
    copyLinkSuccess: 'Has been copied',
    copyUid: 'Copy UID',
    copyMail: 'Copy Email',
    copyLinkFailed: 'Error when copy email',
    text: 'Text',
    byCompany: 'By company',
    changeEmail: 'Change email',
    newEmail: 'New email',
    ban: 'Ban',
    unban: 'Unban',
    setImp: 'Grant a role to log in as another user',
    unsetImp: 'Revoke a role to log in as another user',
    impersonate: 'Impersonate as this user',
    imp: 'Impers.',
  },
};
